export const COMPLETE_ONBOARDING_KEY = 'complete-onboarding';
